module.exports = __webpack_public_path__ + "img/Step-2.60b87691.jpg";